<template>
  <div class="home">
    <h2>計算一覧</h2>
    <p><router-link to="/tapioka">タピオカ</router-link></p>
    <router-link to="/Deviation">偏差値の計算</router-link>
  </div>
</template>

<script>

export default {
  name: 'home',
  data() {
    return {

    }
  },
  mounted(){
    const title = "ホーム｜色々計算サイト"
    const description = "色々計算サイトのホーム画面"
    document.title = title
    document.querySelector("meta[property='og:title']")
    　.setAttribute('content', title)
    document.querySelector("meta[name='description']")
    　.setAttribute('content', description)
    document.querySelector("meta[property='og:description']")
    　.setAttribute('content', description)
  }
}
</script>

<style scoped>
.home{
  margin: auto;
  max-width: 650px;
  text-align: center;
}
</style>

